import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PipelinesService} from "../../../../pipelines.service";

@Component({
  selector: 'pipelines-panel-kpis',
  standalone: false,
  templateUrl: './pipelines-panel-kpis.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-kpis.component.scss', '../../pipelines-table.component.scss']
})
export class PipelinesPanelKpisComponent implements OnInit {
  @Input() detail:any;
  public expanded: boolean;
  public rows: { label: string; key: string }[][] = [];

  private displayFields: { label: string; key: string }[] = [
    { label: 'Total Equity', key: 'total_equity' },
    { label: 'Lower Tier Yield', key: 'lower_tier_yield' },
    { label: 'Hard Debt', key: 'hard_debt' },
    { label: 'Target Yield', key: 'target_yield' },
    { label: 'Subsidy Risk', key: 'subsidy_risk'},
    { label: 'Upper Tier Yield', key: 'ut_yield'},


  ];

  constructor(private _pipelineService: PipelinesService) { }

  ngOnInit(): void {
    this.rows = this._pipelineService.splitExpandedRowChunk(this.displayFields, 2)
  }

  public toggleExpand(){
    this.expanded = !this.expanded;
  }

  protected readonly decodeURI = decodeURI;
}
